import { defineStore } from "pinia";
import GlobalUtil from "../../utils/pricetravel/shared/globalUtil";
import { SearchHistory } from "../../utils/pricetravel/shared/searchHistory";
import BookerTracker from "../../MetricsTracker/booker/metrics";
import { CalendarAvailability } from "../../utils/pricetravel/shared/calendarAvailability";
const fn = window.__pt.fn;
const config = window.__pt.settings.site;
const setting = window.__pt.settings;

const _globalUtil = new GlobalUtil();
const _userKey = _globalUtil.getUserKey();
const _tracker = new BookerTracker();
const defaultDate = fn.getDate();
const _place = window.__pt.place || {};
const __ = (str, values = []) => {
  const _ = window._;
  let formatted = _.get(window.i18n, str, str);

  if (values.length) {
    formatted = _.replace(formatted, /\{\d\}/g, (match) => {
      const index = match.replace(/\{|\}/g, "");
      return values[index] || match;
    });
  }

  return formatted;
};

export const useHotelBookerStore = defineStore("hotelBooker", {
  state: () => ({
    form: {
      type: "todos",
      destination: "",
      dates: "",
      guests: "",
    },
    fieldErrors: {
      destination: "",
      dates: "",
      guests: "",
    },
    book: setting.defaultHotel,
    recentSearches: [],
    popularDestinations: [],
    searchResults: [],
    algoliaUrl:
      "https://img.cdnpth.com/media/assets/recent-search-imgs/places/",
    OpenSearch: false,
    CloseSearch: false,
    lastQuery: "",
    configDaysPrequote: {
      weeksPrequote: 0,
      daysPrequote: 0,
      startDate: 0,
    },
    localeDatePicker: {
      format: setting.formatBoxDate,
      formatMobile: setting.formatBoxDateMobile,
      firstDay: 0,
    },
    settingPaxes: {
      minAdults: 1,
      maxAdults: 8,
      minChildren: 0,
      maxChildren: 6,
      minAge: 0,
      maxAge: 17,
      rooms: 8,
    },
    experimentVar: window.__pt.experimentVar,
    nearbyLocation: {
      name: "",
      show: false,
      coords: null
    }
  }),
  getters: {
    isFormValid(state) {
      return (
        state.form.destination &&
        state.form.destination.trim() !== "" &&
        state.form.dates &&
        state.form.dates.trim() !== "" &&
        state.form.guests &&
        state.form.guests.trim() !== ""
      );
    },
    totalAdults(state) {
      if (_globalUtil.getIsArray(state.book.paxes)) {
        return state.book.paxes.reduce((sum, room) => sum + (room.adults || 0), 0);
      }
      return state.book.paxes.adults || 0;
    },
    paxSummary(state) {
      let adults = state.totalAdults;
      let children = 0;
      let rooms = 0;

      if (_globalUtil.getIsArray(state.book.paxes)) {
        rooms = state.book.paxes.length;
        for (const room of state.book.paxes) {
          adults += room.adults || 0;
          children += room.children ? room.children.length : 0;
        }
      } else if (typeof state.book.paxes === "object") {
        rooms = state.book.paxes.rooms || 1;
        adults = state.book.paxes.adults || 0;
        children = state.book.paxes.children
          ? state.book.paxes.children.length
          : 0;
      }

      const roomTitle = (rooms === 1 ? __('booker.room') : __('booker.rooms')).toLowerCase();
      const adultsTitle = (adults === 1 ? __('booker.adult') : __('booker.adults')).toLowerCase();
      const childrenTitle = (children === 1 ? __('booker.children') : __('booker.childrens')).toLowerCase();

      let childrenText = children > 0 ? ` ${children} ${childrenTitle}, ` : "";
      return `${adults} ${adultsTitle},${childrenText} ${rooms} ${roomTitle}`;
    },
  },
  actions: {
    validateForm(omitField = false) {
      this.clearFieldErrors();
      let valid = true;
      if (!this.book.place_name || !this.form.destination || this.form.destination.trim() === "") {
        if (!omitField) {
          this.setFieldError("destination", __("booker.select_destination"));
        }
        valid = false;
      }
      if (!this.form.dates || this.form.dates.trim() === "") {
        if (!omitField) {
          this.setFieldError("dates", __("booker.select_dates"));
        }
        valid = false;
      }
      if (!this.form.guests || this.form.guests.trim() === "") {
        if (!omitField) {
          this.setFieldError("guests", __("booker.select_guests"));
        }
        valid = false;
      }

      return valid;
    },
    mapPaxToUrl(paxData) {
      let paxesKeys = {};
      let adults = 0;
      let rooms = 0;
      let children = [];

      if (_globalUtil.getIsArray(paxData)) {
        rooms = paxData.length;
        for (const room of paxData) {
          adults += room.adults || 0;
          if (room.children) children.push(...room.children);
        }
      } else if (typeof paxData === "object") {
        adults = paxData.adults || 2;
        rooms = paxData.rooms || 1;
        children = paxData.children || [];
      }

      let kids = 0;
      let infants = 0;
      let agekids = [];

      paxesKeys["group_adults"] = adults;
      paxesKeys["no_rooms"] = rooms;

      if (children.length > 0) {
        kids = children.length;
        paxesKeys["group_children"] = kids;
        for (const child of children) {
          agekids.push(child.year);
          if (child.year > 5) {
            kids += 1;
          } else {
            infants += 1;
          }
        }
      }

      if (agekids.length > 0) {
        paxesKeys["age"] = agekids.join(",");
      }
      if (infants > 0) {
        paxesKeys["infant"] = infants;
      }
      return paxesKeys;
    },
    getPathUri(type) {
      let uri = config.pathHome;
      switch (type) {
        case 6:
        case 3:
        case 11:
        case 7:
        case 12:
          uri = config.pathHoteles;
          break;
        case 14:
          uri = config.pathHotelDetail;
          break;
      }
      return uri;
    },
    getCurrentFiltersFromUrl() {
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split("/").filter((part) => part.length > 0);
      const destinationIndex = pathParts.findIndex((part) =>
        /_[da]\d+$/.test(part),
      );

      if (destinationIndex !== -1 && destinationIndex < pathParts.length - 1) {
        const urlFilters = pathParts.slice(destinationIndex + 1);
        const currentCount =
          typeof window.getSearchModificationCount === "function"
            ? window.getSearchModificationCount()
            : 0;

        if (currentCount === 1 || currentCount === 0) {
          return urlFilters;
        } else if (currentCount >= 2) {
          return [];
        }
        return urlFilters;
      }
      return [];
    },
    submitSearch() {
      if (!this.validateForm()) {
        return;
      }

      let paramsQuery = fn.search();
      let paxesData = this.mapPaxToUrl(this.book.paxes);
      let codept = paramsQuery.coupon;

      let data = {
        adults: this.totalAdults,
        checkin: fn.formatDate(this.book.checkIn, setting.formatDate),
        checkout: fn.formatDate(this.book.checkOut, setting.formatDate),
      };

      if (codept) {
        data.coupon = codept;
      }
      if (this.book.place_selected.cityUrl && config.algoliaDetailIs) {
        data.profileId = this.book.place_selected.code;
      }
      if (paramsQuery.CampaignToken) {
        data.CampaignToken = paramsQuery.CampaignToken;
      }
      if (paramsQuery.campaignTokenApi) {
        data.campaignTokenApi = paramsQuery.campaignTokenApi;
      }
      if (paramsQuery.ctInternal) {
        data.ctInternal = paramsQuery.ctInternal;
      }
      if (paramsQuery.source) {
        data.source = paramsQuery.source;
      }
      if (this.book.isNearby) {
        data.nearby = 1;
      }

      data = { ...data, ...paxesData };

      var path = this.getPathUri(this.book.place_selected.type);
      var hotelIdPath =
        this.book.place_selected.type == 14
          ? `_a${this.book.place_selected.code || this.book.place_selected.id}`
          : `_d${this.book.place_selected.id}`;
      var currentFilters = this.getCurrentFiltersFromUrl();
      var filtersPath =
        currentFilters.length > 0 ? `/${currentFilters.join("/")}` : "";

      _tracker.metricBookerHotel("booker", { vmData: this.book, data });
      var formEl = document.createElement("form");
      formEl.setAttribute("method", "get");
      formEl.setAttribute("action", `${config.siteUrl}${path}${this.book.place_selected.uri}${hotelIdPath}${filtersPath}`);

      for (var key in data) {
        if (data[key]) {
          var hiddenField = document.createElement("input");
          hiddenField.setAttribute("type", "hidden");
          hiddenField.setAttribute("name", key);
          hiddenField.setAttribute("value", data[key]);
          formEl.appendChild(hiddenField);
        }
      }
      SearchHistory.set(this.book, "H");
      if ($("#loader-page").length > 0) {
        $("#loader-page").removeClass("d-none");
      }
      document.body.appendChild(formEl);
      formEl.submit();
    },
    setFieldError(key, value) {
      this.fieldErrors[key] = value;
    },
    clearFieldErrors() {
      this.fieldErrors.destination = "";
      this.fieldErrors.dates = "";
      this.fieldErrors.guests = "";
    },
    getAnalyticsTags() {
      var arrTags = [];
      if (fn.mobileAndTabletCheck()) {
        arrTags.push("web_mobile");
      } else {
        arrTags.push("web_desktop");
      }
      var pathName = _globalUtil.getFirstPathSegment();
      if (pathName == "hotel") {
        arrTags.push("detail");
      } else if (
        (pathName == "hoteles" || pathName == "hotels") &&
        setting.page == "home"
      ) {
        arrTags.push("home");
      } else if (
        (pathName == "hoteles" || pathName == "hotels") &&
        setting.page == "hotels"
      ) {
        arrTags.push("list");
        arrTags.push(window.location.pathname.split("/")[2]);
      } else if (setting.page == "landings") {
        arrTags.push("landings");
      } else {
        arrTags.push("home");
      }
      return arrTags.join(",");
    },
    onSuccessSuggestion(response) {
      const data = response.data || [];
      if (data.length > 0) {
        data.forEach((element) => {
          const [city, ...locationParts] =
            element.type == 11
              ? element.displayHtml.split("-").map((part) => part.trim())
              : element.displayHtml.split(",").map((part) => part.trim());
          element.city =
            element.type == 11
              ? `${locationParts
                .join(", ")
                .replace(" " + element.code + " ", "")} (${element.code})`
              : city;
          element.location =
            element.type === 11
              ? city.replace(element.code + " ", "")
              : locationParts.join(", ");
        });
        return data;
      }
      return [];
    },
    async fetchCalendarAvailability(datesQuote, elements) {
      if (config.showCalendarAvailability) {
        let placeSelected = this.book?.place_selected;
        if (
          placeSelected &&
          placeSelected.type == 14 &&
          (placeSelected.code || placeSelected.id)
        ) {
          CalendarAvailability.setCalendarPriceContainer();
          for (let calendar in datesQuote) {
            let calendarData = calendar.split("_");
            let response = await CalendarAvailability.getAvailability(
              placeSelected.code || placeSelected.id,
              calendarData[0],
              calendarData[1],
            );
            CalendarAvailability.build(elements, response);
          }
          CalendarAvailability.footerBuild();
        }
      }
    },
    async fetchPopularDestinations() {
      if (this.popularDestinations.length > 0) {
        return;
      }
      const params = {
        analyticsTags: this.getAnalyticsTags(),
        from: 0,
        language: config.language,
        placeTypes: 0,
        site: config.code,
        size: 5,
        usersearch: _userKey,
        recommendation: true,
      };
      // Note: Assuming axios is globally accessible as used in the component before
      let response = await axios
        .get(config.endPoints.suggestionHotelUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = this.onSuccessSuggestion(response);
        this.popularDestinations = data;
      }
    },
    async fetchSearchResults(value, mobile) {
      if (!value || (value && value.length < 3)) {
        this.searchResults = [];
        if (!mobile) {
          this.OpenSearch = false;
        }
        return;
      }
      const params = {
        query: value,
        language: config.language,
        placeTypes: config.placesTypeHotel,
        from: 0,
        size: 10,
        usersearch: _userKey,
        site: config.code,
        analyticsTags: this.getAnalyticsTags(),
      };
      let response = await axios
        .get(config.endPoints.suggestionHotelUrl, { params })
        .catch((data) => console.log(data));
      if (response && response.status == 200) {
        const data = response.data || [];
        if (data.length > 0) {
          const src = data || [];
          this.lastQuery = params.query;
          _tracker.metricAutocompleteHotel(params.query, src);
        } else {
          _tracker.metricAutocompleteHotel(params.query, []);
        }
        const searchResult = this.onSuccessSuggestion(response);
        this.searchResults = searchResult;
        if (!mobile) {
          this.OpenSearch = false;
          setTimeout(() => {
            this.OpenSearch = true;
          }, 10);
        }
      }
    },
    loadSearchHistory() {
      this.recentSearches = SearchHistory.getHotel("H");
    },
    updateInputPaxes() {
      this.book.paxes_name = this.paxSummary;
      this.form.guests = this.book.paxes_name;
    },
    selectDestination(destination) {
      this.form.destination = destination.isNearby ? __('booker.nearby_location_name', [destination.place_name]) : destination.place_name;
      this.book.place_name = destination.place_name;
      this.book.place_selected = destination.place_selected;
      this.book.isNearby = destination.isNearby;
      this.CloseSearch = true;
      this.OpenSearch = true;
      setTimeout(() => {
        this.OpenSearch = false;
      }, 10);
    },
    initialDefaultDate() {
      if (fn.mobileAndTabletCheck()) {
        this.configDaysPrequote.weeksPrequote =
          config.configDaysPrequoteMobile.weeksPrequote;
        this.configDaysPrequote.daysPrequote =
          config.configDaysPrequoteMobile.daysPrequote;
        this.configDaysPrequote.startDate =
          config.configDaysPrequoteMobile.startDate;
      } else {
        this.configDaysPrequote.weeksPrequote =
          config.configDaysPrequoteDesktop.weeksPrequote;
        this.configDaysPrequote.daysPrequote =
          config.configDaysPrequoteDesktop.daysPrequote;
        this.configDaysPrequote.startDate =
          config.configDaysPrequoteDesktop.startDate;
      }
      const newDateParse = new Date(defaultDate);
      newDateParse.setDate(
        newDateParse.getDate() + this.configDaysPrequote.weeksPrequote * 7,
      );
      newDateParse.setDate(
        newDateParse.getDate() -
        newDateParse.getDay() +
        this.configDaysPrequote.startDate,
      );

      let dateIn = fn.getDate(fn.formatDate(newDateParse, setting.formatDate));

      let dateOut = fn.getDate(fn.formatDate(newDateParse, setting.formatDate));
      dateOut.setDate(dateOut.getDate() + this.configDaysPrequote.daysPrequote);

      this.book.checkIn = dateIn;
      this.book.checkOut = dateOut;
    },
    getUserSelectionParams() {
      let params = fn.search();
      let data = {};
      let place = _place;
      this.book.place_name = place.displayText || "";
      this.book.place_selected = place;
      data.checkIn = params.checkin || this.book.checkIn;
      data.checkOut = params.checkout || this.book.checkOut;
      let pax = { adults: 0, children: [], rooms: 0 };
      if (params["room1.adults"]) {
        let rooms = +params.rooms;
        pax.rooms = rooms;
        for (let i = 0; i < rooms; i++) {
          let index = i + 1;
          pax.adults =
            parseInt(pax.adults) + parseInt(params[`room${index}.adults`]) || 2;
          let children = params[`room${index}.agekids`];
          if (children) {
            let childrenSplit = children.split(",");
            for (var c = 0; c < childrenSplit.length; c++) {
              pax.children.push({ year: +childrenSplit[c] || 0 });
            }
          }
        }
      } else {
        var adults = +params.group_adults || 2;
        var rooms = +params.no_rooms || 1;
        var children = [];
        var childrenCount = +params.group_children || 0;
        for (let i = 0; i < childrenCount; i++) {
          var childParam = (params.age || "").split(",")[i];
          var childAge = +childParam || 0;
          children.push({ year: childAge });
        }
        pax.adults = adults;
        pax.rooms = rooms;
        pax.children = children;
      }
      if (!pax) {
        pax = this.book.paxes;
      }
      data.paxes = pax;
      return data;
    },
    initSearchBox() {
      let paramsData, storageData;
      if (setting.page != "home") {
        paramsData = this.getUserSelectionParams();
      } else {
        storageData = SearchHistory.getFirstEntry("H");
      }
      if (storageData) {
        storageData.place_name = null;
        storageData.place_selected = {};
      }
      this.book = paramsData || storageData || this.book;
      if (_globalUtil.getIsArray(this.book.paxes)) {
        this.book.paxes = _globalUtil.convertPaxesData(this.book.paxes);
      }
      if (paramsData || storageData) {
        this.book.checkIn = fn.getDate(this.book.checkIn);
        this.book.checkOut = fn.getDate(this.book.checkOut);
        if (
          +this.book.checkIn <= +defaultDate ||
          +this.book.checkOut <= +defaultDate
        ) {
          this.initialDefaultDate();
        }
      }
    },
    setNearbyLocation(location) {
      this.nearbyLocation = {
        ...this.nearbyLocation,
        ...location,
        show: true
      };
    },
  },
});
